import NaoConformidadeNova from './NaoConformidadeNova';

export default NaoConformidadeNova;